import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Drawer from "../../../Component/Drawer";

// STATIC DESIGN — edit customer drawer, prefilled from the user record.
// Saving is not wired to an API yet (the /customers-and-users/edit-user page is still empty).
export const ONBOARDING_STEPS = ["Registered", "Email verified", "Business details", "WABA connected", "Plan active", "Went live"];
const COMPANY_SIZES = ["1-20", "20-50", "50-200", "200-500", "500+"];

interface EditCustomerDrawerProps { show: boolean; onClose: () => void; user: any }

const EditCustomerDrawer = ({ show, onClose, user }: EditCustomerDrawerProps) => {
  const [form, setForm] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!show || !user) return;
    setForm({
      company: user.user_companyName || "",
      first: user.user_first_name || "",
      last: user.user_last_name || "",
      email: user.user_email || "",
      mobile: user.user_mobile || "",
      industry: user.user_industry || "",
      size: user.user_companySizeRange || "",
      website: user.user_website || "",
      setup: String(user.user_account_setup ?? 0),
    });
  }, [show, user]);

  const set = (k: string, v: string) => setForm(f => ({ ...f, [k]: v }));

  const save = () => {
    if (!form.email?.trim()) return toast.warning("Email is required");
    toast.info("Customer details updated · demo only, not saved");
    onClose();
  };

  const field = (key: string, label: string, props: React.InputHTMLAttributes<HTMLInputElement> = {}, full = false) => (
    <div className={full ? "full" : ""}>
      <label className="cx-label">{label}</label>
      <input className="cx-input" value={form[key] || ""} onChange={(e) => set(key, e.target.value)} {...props} />
    </div>
  );

  return (
    <Drawer
      show={show}
      onClose={onClose}
      title="Edit customer"
      subtitle={<span className="mono">#{user?.user_unique_id}</span>}
      footer={<>
        <button type="button" className="cx-btn cx-btn-light" onClick={onClose}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={save}>Save changes</button>
      </>}
    >
      <div className="cx-fgrid">
        {field("company", "Business name", {}, true)}
        {field("first", "First name")}
        {field("last", "Last name")}
        {field("email", "Email", { type: "email" })}
        <div>
          <label className="cx-label">Mobile</label>
          <div style={{ display: "flex", gap: 8 }}>
            <span className="cx-input mono" style={{ width: 64, display: "grid", placeItems: "center", background: "#f7f8fa", flex: "none" }}>+{user?.user_country_code || "91"}</span>
            <input className="cx-input mono" style={{ flex: 1, minWidth: 0 }} inputMode="tel" value={form.mobile || ""} onChange={(e) => set("mobile", e.target.value)} />
          </div>
        </div>
        {field("industry", "Industry")}
        <div>
          <label className="cx-label">Company size</label>
          <select className="cx-select" value={form.size || ""} onChange={(e) => set("size", e.target.value)}>
            <option value="">—</option>
            {COMPANY_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        {field("website", "Website", { type: "url" }, true)}
        <div className="full">
          <label className="cx-label">Onboarding stage</label>
          <select className="cx-select" value={form.setup || "0"} onChange={(e) => set("setup", e.target.value)}>
            {ONBOARDING_STEPS.map((s, i) => <option key={s} value={i}>{i}. {s}</option>)}
          </select>
        </div>
      </div>
      <p className="cx-help" style={{ marginTop: 14 }}><i className="ri-information-line"></i> Demo only — this form is not connected to the backend yet, nothing is saved.</p>
    </Drawer>
  );
};

export default EditCustomerDrawer;
